import { z } from 'zod';
import { addressSchema } from '@/schemas/API/common/basic/address';
import { id } from '@/schemas/API/common/atomic/id';
import { accessSchema } from '@/schemas/API/common/basic/access';
import { pageableSchema } from '../pageable/response';
import { phone } from '@/schemas/API/common/atomic/phone';
import { sex } from '@/schemas/API/common/atomic/sex';
import { date } from '@/schemas/API/common/atomic/date';
import { emergencyContactSchema } from '@/schemas/API/common/basic/emergencyContact';
import { email } from '@/schemas/API/common/atomic/email';
import { empTimeSchema, empTypeSchema } from '../../POST/employee/request';
import { employeeCardSchema } from '@/schemas/API/common/basic/employeeCard';
import { tagSchema } from '@/schemas/API/common/basic/tag';

const courseSchema = z.object({
  name: z.string().min(1),
  date,
  hours: z.number().min(1),
});

const languageSkillSchema = z.object({
  id: z.number(),
  name: z.string().min(1, ' '),
  level: z.string().min(1, ' '),
});

const LocationSchema = z.object({
  id: z.number(),
  name: z.string().min(1),
});


export const employeeDetailedSchema = z.object({
  id,
  firstName: z.string().min(1, {message: 'Jméno musí být dlouhé aspoň 2 znaky'}),
  lastName: z.string().min(1, {message: 'Příjmení musí být dlouhé aspoň 2 znaky'}),
  title: z.string().nullable().transform(e => e?.trim() === "" ? null : e),
  sex,
  phone,
  email,
  birthdate: date,
  birthplace: z.string().min(1, 'Místo narození můsí být dlouhé aspoň 2 znaky'),
  eduType: z.string().min(1, 'Typ vzdělání musí být dlouhé aspoň 2 znaky'),
  numOfVacationDays: z.number().nullable(),
  empType: empTypeSchema,
  empTime: empTimeSchema,
  optimum: z.number(),
  canFirstAid: z.boolean(),
  permAddress: addressSchema,
  courses: z.array(courseSchema),
  langs: z.array(languageSkillSchema),
  contacts: z.array(emergencyContactSchema),
  cards: z.array(employeeCardSchema),
  locs: z.array(LocationSchema),
  tags: z.array(tagSchema),
  active: z.boolean().nullable(),
  contractEnd: date.nullable(),
  access: accessSchema,
});

const employeeSchema = z.object({
  id,
  firstName: z.string(),
  lastName: z.string(),
  phone,
  permAddress: addressSchema,
  active: z.boolean().optional(),
  access: accessSchema,
  tags: z.array(tagSchema),
  locs: z.array(LocationSchema),
  contractEnd: date.nullable(),
});

const employeesSchema = z
  .object({
    content: z.array(employeeSchema),
  })
  .merge(pageableSchema);

export type Employee = z.infer<typeof employeeSchema>;
export type Employees = z.infer<typeof employeesSchema>;
export type EmployeeDetailed = z.infer<typeof employeeDetailedSchema>;
export type EmployeeLanguages = z.infer<typeof languageSkillSchema>;
